import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { signIn, getAuthNumber, resetPassword } from "api/signin";

const initialState = {
  phoneNumber: "",
};

export const fetchSignIn = createAsyncThunk(
  "signin/fetchSignIn",
  async (payload) => {
    return await signIn(payload);
  }
);

export const fetchGetAuthNumber = createAsyncThunk(
  "signin/fetchGetAuthNumber",
  async (payload) => {
    return await getAuthNumber(payload);
  }
);

export const fetchResetPassword = createAsyncThunk(
  "signin/fetchResetPassword",
  async (payload) => {
    return await resetPassword(payload);
  }
);

const signinSlice = createSlice({
  name: "signin",
  initialState,
  reducers: {
    setPhoneNumber(state, action) {
      state.phoneNumber = action.payload;
    },
  },
  extraReducers: {
    // [fetchGetAuthNumber.fulfilled]: (state, action) => {},
  },
});

export const { setPhoneNumber } = signinSlice.actions;

export default signinSlice.reducer;
